import { FormShell, Field, useFormSubmit, Success } from "@/components/forms/FormShell";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import api from "@/lib/api";

export default function Contact() {
  const { loading, done, submit } = useFormSubmit("/contact");
  const onSubmit = (e) => {
    e.preventDefault();
    submit(Object.fromEntries(new FormData(e.target)), api);
  };
  return (
    <FormShell
      kicker="Contact"
      title="Get in touch with our team"
      description="Fitment questions, order support, or wholesale inquiries — we're here to help."
    >
      <div className="grid md:grid-cols-3 gap-3 mb-8">
        <a data-testid="contact-info-phone" href="tel:+16267103581" className="rounded-xl border border-slate-200 bg-slate-50 hover:border-[#0055FF] transition-colors p-4 flex items-start gap-3">
          <div className="w-9 h-9 rounded-md bg-[#0055FF]/10 text-[#0055FF] flex items-center justify-center shrink-0"><Phone className="w-4 h-4" /></div>
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Phone</div>
            <div className="text-slate-900 font-heading font-semibold">(626) 710-3581</div>
          </div>
        </a>
        <a data-testid="contact-info-email" href="mailto:intercorpindustries1@gmail.com" className="rounded-xl border border-slate-200 bg-slate-50 hover:border-[#0055FF] transition-colors p-4 flex items-start gap-3">
          <div className="w-9 h-9 rounded-md bg-[#0055FF]/10 text-[#0055FF] flex items-center justify-center shrink-0"><Mail className="w-4 h-4" /></div>
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Email</div>
            <div className="text-slate-900 font-heading font-semibold break-all">intercorpindustries1@gmail.com</div>
          </div>
        </a>
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 flex items-start gap-3">
          <div className="w-9 h-9 rounded-md bg-[#0055FF]/10 text-[#0055FF] flex items-center justify-center shrink-0"><Clock className="w-4 h-4" /></div>
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Business hours</div>
            <div className="text-slate-900 font-heading font-semibold">Mon–Fri · 9am–6pm ET</div>
          </div>
        </div>
      </div>
      {done ? (
        <Success message="We received your message. Our team will respond during business hours." />
      ) : (
        <form onSubmit={onSubmit} className="space-y-5" data-testid="contact-form">
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Full name" name="name" required />
            <Field label="Email" name="email" type="email" required />
            <Field label="Phone" name="phone" />
            <Field label="Subject" name="subject" />
          </div>
          <div>
            <Label className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Message *</Label>
            <Textarea data-testid="field-message" name="message" rows={6} required className="mt-1.5" />
          </div>
          <Button type="submit" disabled={loading} className="bg-[#0055FF] hover:bg-[#0044CC] h-11 px-6" data-testid="contact-submit">
            {loading ? "Sending…" : "Send message"}
          </Button>
        </form>
      )}
    </FormShell>
  );
}
